// Organisation-group types. Must stay in sync with the backend
// OrgGroup.GroupType text choices (power_backend/org/models.py).
export const GROUP_TYPES = [
    { value: 'trust', label: 'Multi-academy trust' },
    { value: 'local_authority', label: 'Local authority' },
    { value: 'federation', label: 'Federation' },
    { value: 'other', label: 'Other' }
]

export function groupTypeLabel(value) {
    return GROUP_TYPES.find((type) => type.value === value)?.label ?? value
}
